import {config} from './src/config';
// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

Sentry.init({
  dsn: 'https://7ab947ef059f46f48d2029c439bc1aa6@o294615.ingest.sentry.io/6270978',
  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 0.4,
  environment: config.appEnv,
  // ...
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
});
